import { Modal } from "react-bootstrap";

const CustomModal = ({
  show,
  onHide,
  isHeader = true,
  title,
  footer,
  size = "lg",
  children,
  className,
  ...otherProps
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size={size}
      centered
      className={`rtl ${className}`}
      contentClassName="bg-dark"
      {...otherProps}
    >
      {isHeader && (
        <Modal.Header className="d-flex justify-content-between align-items-center">
          {title && (
            <Modal.Title className="fa-1_1x fw-bold">{title}</Modal.Title>
          )}
          <i
            className="la la-times cursor-pointer fa-1_2x text-muted"
            onClick={onHide}
          />
        </Modal.Header>
      )}
      <Modal.Body>
        <div className="kf-reservation-form">{children}</div>
      </Modal.Body>
      {footer && <Modal.Footer>{footer}</Modal.Footer>}
    </Modal>
  );
};

export default CustomModal;
